module.exports = __webpack_public_path__ + "tempo-src-icon.png?b0f987648b729e94b4013ade30d9f79f";